import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type GetPipelineItemTemplateDataQueryVariables = Types.Exact<{
   params: Types.GetSalesTemplatesParams
}>

export type GetPipelineItemTemplateDataQuery = {
   __typename?: 'Query'
   getSalesTemplates: {
      __typename?: 'GetSalesTemplateResult'
      salesTemplates: Array<
         | { __typename?: 'ContactTemplate' }
         | {
              __typename?: 'PipelineItemTemplate'
              name: string
              pipelineItemTemplateId: string
              pipelineItemType: Types.PipelineItemType
              customObjectTemplateProperties?: {
                 __typename?: 'CustomObjectTemplateProperties'
                 singularName: string
                 primaryDisplayNameFieldId: string
                 pluralName: string
              } | null
              applicationTemplateProperties?: {
                 __typename?: 'ApplicationTemplateProperties'
                 singularName: string
                 pluralName: string
                 primaryDisplayNameFieldId: string
              } | null
           }
         | {
              __typename?: 'SalesTemplateAccessDenied'
              message?: string | null
              salesTemplateId: string
           }
         | {
              __typename?: 'SalesTemplateNotFound'
              message?: string | null
              salesTemplateId: string
           }
      >
   }
}

export const GetPipelineItemTemplateDataDocument = gql`
   query GetPipelineItemTemplateData($params: GetSalesTemplatesParams!) {
      getSalesTemplates(params: $params) {
         ... on GetSalesTemplateResult {
            salesTemplates {
               ... on PipelineItemTemplate {
                  name
                  pipelineItemTemplateId
                  pipelineItemType
                  customObjectTemplateProperties {
                     singularName
                     primaryDisplayNameFieldId
                     pluralName
                  }
                  applicationTemplateProperties {
                     singularName
                     pluralName
                     primaryDisplayNameFieldId
                  }
               }
               ... on SalesTemplateNotFound {
                  message
                  salesTemplateId
               }
               ... on SalesTemplateAccessDenied {
                  message
                  salesTemplateId
               }
            }
         }
      }
   }
`
export type GetPipelineItemTemplateDataQueryResult = Apollo.QueryResult<
   GetPipelineItemTemplateDataQuery,
   GetPipelineItemTemplateDataQueryVariables
>
